(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('Documo', Documo);

    Documo.$inject = ['$resource'];

    function Documo ($resource) {
        var resourceUrl =  'api/documos/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            "findAllDocumos":{url: 'api/documos', method: 'GET', isArray: true},
            'update': { method:'PUT' }
        });
    }
})();
